import React, { FC } from "react";
import { useSelector } from "react-redux";
import { IconButton, ThemeName } from "@evergis/ui";

import { getThemeName } from "../../../ducks/theme/selectors";
import { useProjectMenu } from "../hooks/useProjectMenu";
import { useProjectPanel } from "../hooks/useProjectPanel";

export const ThemeSwitcher: FC = () => {
  const themeName = useSelector(getThemeName);
  const { config } = useProjectPanel();
  const { toggleTheme } = useProjectMenu(config);

  return <IconButton kind={themeName === ThemeName.Dark ? "moon" : "sun"} primary onClick={toggleTheme} />;
};
